import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { ErrorDispatcherService } from '../../../core/services/error/error-dispatcher.service';
import {
  CAMPAIGN_PRODUCT_PARAMETER_NAME,
  CAMPAIGN_PRODUCTS,
} from '../../../pages/campaign/campaign-page/campaign.product.types';

export const campaignGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const router: Router = inject(Router);
  const errorDispatcherService: ErrorDispatcherService = inject(ErrorDispatcherService);

  const product = route.params[CAMPAIGN_PRODUCT_PARAMETER_NAME];

  if (CAMPAIGN_PRODUCTS.includes(product)) {
    return true;
  }

  errorDispatcherService.handleError({
    name: 'CampaignGuardError',
    message: `Wrong product found in path. product: ${product}`,
  });

  return router.parseUrl('/');
};
